import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9fb3b6da")

_pushScopeId("data-v-9fb3b6da")
const _hoisted_1 = { class: "ui__footer_main" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "ui__footer_report" }, " 本次服务由 [闲鱼合作伙伴-268V] 提供 ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
})